import React, { Component } from "react";

class SearchOrder extends Component {
	render() {
		return (
			<div>
				{this.props.items.length ? (
					<table className="display_table">
						<thead>
							<tr className="table-header">
								<th />
								<th>Invoice Id</th>
								<th>Date</th>
								<th>Email</th>
								<th />
							</tr>
						</thead>
						<tbody>
							{this.props.items.map((item, i) => (
								<tr className="clickable" key={i} onClick={() => this.props.history.push(this.props.basePath + "/" + item.id)}>
									<td className="record-number">{i + this.props.startPosition + 1}</td>
									<td data-id="Invoice Id">{item.invoiceid}</td>
									<td data-id="Date">{item.timestamp}</td>
									<td data-id="Email">{item.email}</td>
									<td className="edit-cell">
										<div className="edit_btn">View</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<div>No Results</div>
				)}
			</div>
		);
	}
}

SearchOrder.defaultProps = {
	items: [],
	startPosition: 0,
	clickHandle: null
};

export default SearchOrder;



// WEBPACK FOOTER //
// ./src/components/search/SearchOrder.js